// Application adapter: keep separate from the generated deployment package.

import MA_LEVEL_ABI from '../v2/abi/ma-v2.json'
import MANAGER_ABI from './abi/MerchantManager.json'
import { MerchantData as BaseMerchantData } from './merchant'
import { MA_V2, MERCHANT_MANAGER } from './network'
import { CreateContract, GetGlobalSigner, BN, WeiToUnits } from '../../ethers/e'

export * from './merchant'
export { MerchantStairData, MigrateStair, SettleLegacyStair, CvcdExitData, ClaimCvcdExit } from './migration'

export async function InitialIdentityData(account) {
    const signer = GetGlobalSigner()
    const ma = CreateContract(MA_V2, MA_LEVEL_ABI, signer)
    const manager = CreateContract(MERCHANT_MANAGER, MANAGER_ABI, signer)
    const [levels, identity] = await Promise.all([
        ma.userLevels(account), manager.getMerchantIdentity(account)
    ])
    return {
        eligible: BN(levels.selfLevel).gte(2),
        memberAvailable: BN(identity.userExpiry).isZero(),
        vipAvailable: BN(identity.boleExpiry).isZero()
    }
}
InitialIdentityData.Type = { eligible: false, memberAvailable: false, vipAvailable: false }

export function ClaimInitialIdentities() {
    return CreateContract(MERCHANT_MANAGER, MANAGER_ABI, GetGlobalSigner()).claimInitialIdentities()
}

// Keep frontend reward breakdowns outside the replaceable deployment helpers.
export async function MerchantData(account) {
    const manager = CreateContract(MERCHANT_MANAGER, MANAGER_ABI, GetGlobalSigner())
    const [data, breakdown] = await Promise.all([
        BaseMerchantData(account), manager.getReferralRewardBreakdown(account)
    ])
    return {
        ...data,
        rewards: {
            ...data.rewards,
            ...Object.fromEntries(['direct', 'indirect', 'team', 'unclassified'].map(key => [
                key, { totalAmount: WeiToUnits(breakdown[`${key}Amount`], 18) }
            ]))
        }
    }
}
MerchantData.Type = {
    ...BaseMerchantData.Type,
    rewards: {
        ...BaseMerchantData.Type.rewards,
        direct: { totalAmount: '0' }, indirect: { totalAmount: '0' },
        team: { totalAmount: '0' }, unclassified: { totalAmount: '0' }
    }
}
